var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHammerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2334 1.84961V4.62793L22.5928 3.43652L22.6084 3.43359H25.1504V16.4004H22.6084L22.5928 16.3965L15.5 14.8203L8.40723 16.3965L8.3916 16.4004H5.84961V3.43359H8.3916L8.40723 3.43652L13.7666 4.62793V1.84961H17.2334ZM6.94141 15.3086H8.26562L15.2939 13.7432L15.375 13.7256L15.3828 13.7334C15.489 13.7199 15.5991 13.725 15.7051 13.748H15.7061L22.7324 15.3086H24.0586V4.52539H22.7285L15.7012 6.08496C15.5701 6.11471 15.4291 6.11414 15.2949 6.08496H15.2939L8.27148 4.52539H6.94141V15.3086ZM14.8584 4.86816L15.5 5.0127L16.1416 4.86816V2.94141H14.8584V4.86816ZM17.2334 27.4834H13.7666V16.5205L13.8838 16.4941L14.6758 16.3164L14.8584 16.2754V26.3916H16.1416V16.2705L16.3242 16.3115L17.1162 16.4893L17.2334 16.5156V27.4834Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerIcon);
export default __webpack_public_path__ + "static/media/hammer-icon.ebaf1eedbd4b34e7ce1b4ee41ffd4a07.svg";
export { ForwardRef as ReactComponent };